import { render } from "./giftCard.vue?vue&type=template&id=a2ee11e4&scoped=true&ts=true"
import script from "./giftCard.vue?vue&type=script&lang=ts"
export * from "./giftCard.vue?vue&type=script&lang=ts"

import "./giftCard.vue?vue&type=style&index=0&id=a2ee11e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ee11e4"]])

export default __exports__